import React from "react";
import { Link } from "react-router-dom";
import { usePreviewMode } from "../edit/PreviewModeContext";
import { getPreviewPathFor } from "../edit/pageRegistry";
import EditableText from "../edit/EditableText";
import PageCopyright from "../edit/PageCopyright";
import { PAGE_TITLE_STYLE } from "../edit/textStyles";

const sermonSeries = [
  {
    title: "2023 马可福音",
    route: "/mark-2023"
  },
  {
    title: "2022 罗马书",
    route: "/romans-2022",
  },
  {
    title: "2022 约书亚记",
    route: "/joshua-2022",
  },
  {
    title: "2020 创世纪",
    route: "/genesis-2020",
  },
  {
    title: "其他讲道",
    route: "/other-sermons",
  }
];

function SermonsPage() {
  const { isPreview } = usePreviewMode();
  const resolveTo = (to) => (isPreview ? getPreviewPathFor(to) : to);

  return (
    <div className="main-content" style={{ maxWidth: 1000, margin: "0 auto", padding: 24 }}>
      <EditableText id="sermons.title" defaultContent="讲道信息" defaultStyle={PAGE_TITLE_STYLE} />
      <div style={{
    display: "flex",
    flexDirection: "column",
    gap: 32,
    marginTop: 40,
    // No need for justifyItems or gridTemplateColumns
   }}>
        {sermonSeries.map(series => (
          <div
            key={series.title}
            style={{
              border: "1px solid #bbbbbb",
              borderRadius: 0,
              background: "#ffffff",
              padding: 12,                // reduced padding
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              maxWidth: 400,
              width: "100%",
              boxSizing: "border-box",
              maxHeight: 150,             // add scroll if content overflows
            }}
          >
            <Link to={resolveTo(series.route)} style={{
              color: "#000000",
              padding: "8px 24px",
              fontWeight: 600,
              fontSize: "1em",
            }}><EditableText id={`sermons.series-${series.route.replace(/\//g, "")}`} as="h2" defaultContent={series.title} defaultStyle={{ color: "#000000", fontWeight: 700, textDecoration: "underline", fontSize: "1.2em", marginBottom: "12px" }} />
            </Link>
            <Link to={resolveTo("/")} style={{
              color: "#000000",
              padding: "8px 24px",
              fontWeight: 600,
              fontSize: "1em",
            }}><h2 style={{ color: "#aaaaaa", fontWeight: 700, fontSize: "0.9em", marginBottom: 12 }}>香槟厄巴纳生命河教会</h2>
            </Link>
            <div style={{ marginBottom: 16, color: "#000000", minHeight: 40 }}>{series.description}</div>
            
          </div>
        ))}
      </div>
      <PageCopyright pageId="sermons" />
    </div>
  );
}

export default SermonsPage; 